import request from '@/api/config/request'

const prex = "api/autocomplete/";

export function autocompleteServicos(query = {}) {
    return request({
        url: `${prex}servicos`,
        method: 'get',
        params: query
    })
}

export function autocompleteCnae(query = {}) {
    return request({
        url: `${prex}cnae`,
        method: 'get',
        params: query
    })
}

export function autocompletePaises(query = {}) {
    return request({
        url: `${prex}paises`,
        method: 'get',
        params: query
    })
}

export function autocompleteMunicipio(query = {}) {
    return request({
        url: `${prex}municipio`,
        method: 'get',
        params: query
    })
}

export function autocompleteEmpresas(query = {}) {
    return request({
        url: `${prex}empresas`,
        method: 'get',
        params: query
    })
}

export function autocompleteEleicoes(query = {}) {
    return request({
        url: `${prex}eleicoes`,
        method: 'get',
        params: query
    })
}
